/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import numeral from 'numeral';
import moment from 'moment';

const WyUtils = {
  languageMap: {
      "en": 'English',
      "fr": 'French'
  },

  isValidUrl(str) {
    //let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    //let regexp = /^(ftp|https?):\/\/+(www\.)?[a-zA-Z0-9\-\.]{3,}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/
    //let regexp = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    //return regexp.test(this);
    let isValid = str.indexOf('http') == 0;
    return isValid;
  },

  maxString(str, len, more) {
    if(str.length > len) {
      return str.substring(0, len) + more;
    }
    return str;
  },
  
  toInt(val, defaultVal) {
    let intVal = parseInt(val);
    if(isNaN(intVal)) {
        return defaultVal ? defaultVal : 0;
    }
    else {
        return intVal;
    }
  },

  toUpperCaseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },

  toCamelCase(str) {
    return  (" " + str).toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function(match, chr)
    {
        return chr.toUpperCase();
    });
  },

  isObjEmpty(obj) {
    return (Object.keys(obj).length === 0 && obj.constructor === Object);
  },

  toString(val, defVal) {
    return val ? val.trim() : defVal;
  },

  urlEncode(val) {
    return val ? encodeURIComponent(val).trim() : ''
  },

  calcTextWidth(val, fontSize) {
    let divPlaceholder = document.getElementById('spanPlaceholder');
    divPlaceholder.innerHTML = val;
    divPlaceholder.style.fontSize = fontSize+'px'
    return divPlaceholder.offsetWidth;
  },

  textWidth(text, fontStyle) {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    context.font = fontStyle;
    return context.measureText(text).width;
  },

  copyToClipboard(str) {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  },

  formatterText(val) {
    return val ? val.replace(/<br\/>/g, '\n') : '';
  },
  formatterNumber(val, format='0,0.[00]') {
    return val ? numeral(val).format(format) : '0';
  },
  formatterFloatNumber(val) {
    return val ? numeral(val).format('0,0.00') : '0';
  },
  formatterPercentage(val) {
    return val ? numeral(val).format('0%') : '0%';
  },
  formatDate(date, format="MMM DD, YYYY") {
    return moment(date,'YYYY-MM-DD').format(format);
  },
  formatDateWithDay(date) {
    return moment(date,'YYYY-MM-DD').format("ddd MMM DD, YYYY");
  },

  getTransform(element){
    var transform = element.getAttribute("transform");
    var split = transform.split(",");
    if(split && split.length > 1) {
        var x = parseFloat(split[0].split("(")[1]);
        var y = parseFloat(split[1].split(")")[0]);
        var scale = 1;

        if(transform.indexOf("scale") > 6) {
          scale = parseFloat(transform.substring(transform.indexOf("scale")+6, transform.length-1));
        }

        return {"x": x, "y": y, "scale": scale};
    }else{
        return {"x": 0, "y": 0, "scale": 0};
    }
  },

  toNiceTimeFormat(secs) {
    secs = Number(secs);
    if(secs >= 1){
      var h = Math.floor(secs / 3600);
      var m = Math.floor(secs % 3600 / 60);
      var s = Math.round(secs % 3600 % 60);
      
      if(h == 0 && m == 0 && s < 10) {
        // print second decimal if it is less then 10 seconds
        s = (secs % 3600 % 60).toFixed(1);
      }

      if(s == 60) {m = m + 1; s = 0 }

      var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : ""; // NOSONAR
      var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : ""; // NOSONAR
      var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "00s"; // NOSONAR
      return hDisplay + mDisplay + sDisplay; 
    }
    else{
      if(secs == 0) {
        return "0s";
      }
      else{
        return "less than 1s";
      }
    }
  },

  toNiceTimeFormatFromMinus(mins) {
    return this.toNiceTimeFormat(mins * 60);
  },

  getTimeRange(transcript) {
    if(transcript && transcript.messages && transcript.messages.length > 1) {
      let sTime = this.dateTimeValidation(transcript.messages[0].datetime)
      let eTime = this.dateTimeValidation(transcript.messages[transcript.messages.length-1].datetime)
      let startTime = moment(sTime).format("h:mm a");
      let endTime = moment(eTime).format("h:mm a");
      return startTime + ' - ' + endTime;
    }
    else if(transcript && transcript.messages && transcript.messages.length  == 1) {
      let sTime = this.dateTimeValidation(transcript.messages[0].datetime);
      return moment(sTime).format("h:mm a") + ' - ' + moment(sTime).format("h:mm a");
    }
    else {
      return ''
    }
  },

  dateTimeValidation(dateTime) {
    let length = dateTime.length
    //fixing the issue with '2021-02-01 19:07:390000'
    if(dateTime.substring(length-4, length) == '0000') {
      dateTime = dateTime.substring(0, length-4) + '.000';
    }
    return dateTime;
  },

  getDateRangeType(type) {
    let dStart = moment(new Date(), "DD-MM-YYYY");
    let dEnd = moment(new Date(), "DD-MM-YYYY");
    
    if(type == 0) { // today
      // do nothing
    }
    else if(type == 1) { // yesterday
      dStart.add(-1, 'days');
      dEnd.add(-1, 'days');
    }
    else if(type == 2) { // last 7 days
      dStart.add(-6, 'days');
    }
    else if(type == 3) { // last 30 days
      dStart.add(-29, 'days');
    }
    else if(type == 4) { // last 3 months
      dStart.add(-3, 'M');
    }
    else if (type == 5) { // Year to date
      dStart = moment(new Date(), "DD-MM-YYYY").startOf('year');
    }
    else if(type == 6) { // last year (OC-1730: Last 12 months)
      dStart.add(-1, 'Y');
    }
    return {
      start: dStart,
      end: dEnd
    }
  },

  toTranscriptLabel(key) {  
    key = key.toUpperCase();
    let map = {
      "U": "Customer",
      "USER": "Customer",
      "B": "Virtual Agent",
      "BOT": "Virtual Agent",
      "CUSTOMER": "Customer",
      "CONSUMER": "Customer",
      "AGENT": "Live Agent",
      "A": "Live Agent",
      "T": "Live Agent",
      "C": "Customer",  
      "Client": "Customer",
      "S": "System",
      "SYSTEM": "System",
    }    
    if(map[key]) {
      return map[key];
    }
    return key;
  },

  findMedian(arrValue) {
    const arr = arrValue.filter(val => val!=null);
    const len = arr.length;
    const arrSort = arr.sort(function(a, b) { return a - b; });
    const mid = Math.ceil(len / 2);
    const median = len % 2 == 0 ? (arrSort[mid] + arrSort[mid - 1]) / 2 : arrSort[mid - 1];
    
    return median
  },

  getTimeDiff(date) {
    // expects Date object (e.g. new Date())
    if(date){
      return (new Date()).getTime() - date.getTime();
    }
    else {
      return 0;
    }
},

  calculatePercentage(dataA, dataB) {
    if(dataB - dataA == 0) {
      return 0;
    }
    else if(isFinite((dataB - dataA) / dataA * 100)){
      return ((dataB - dataA) / dataA * 100).toFixed(2);
    }
    else{
      return 100;
    }
  },

  isSameFiltersValues(oringalFilters, newFilters) {
    if(typeof oringalFilters === 'object') {
      if(Array.isArray(oringalFilters)) {        
        return oringalFilters.find(el => !newFilters.includes(el))==null && newFilters.find(el => !oringalFilters.includes(el))==null;
      }
      else {
        let isSame = true;
        for(const key in oringalFilters) {
          const item1 = oringalFilters[key];
          const item2 = newFilters[key];
          if(item1 !=null && item2 !=null) {
            isSame = this.isSameFiltersValues(item1, item2);
            if(!isSame) {
              break;
            }
          }
          else {
            isSame = false;
          }
        }
        return isSame;
      }
    }
    else {
      return oringalFilters == newFilters;
    }
  },

  bigNumberFormatter(num) {
    if (num >= 1000000000) {
       return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
       return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
       return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
  },
  
  isSameArrayWithNullHandling(arr1, arr2) {
    let arraySame = true;
    if(arr1 != null && arr2 != null) {
      arr1.forEach(item=>{
        if(!arr2.includes(item)) {
          arraySame = false
        }
      })
      arr2.forEach(item=>{
        if(!arr1.includes(item)) {
          arraySame = false
        }
      })
    }
    else {
      if(arr1 == null) {
        if(arr2 == null || arr2.length == 0) {
          arraySame = true;
        }
        else {
          arraySame = false;
        }
      }
      else if(arr2 == null) {
        if(arr1 == null || arr1.length == 0) {
          arraySame = true;
        }
        else {
          arraySame = false;
        }
      }
    }
    return arraySame;
  },

  convertObjToCSV(objArray) {
    let items = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let csvContent = '';

    for (let i = 0; i < items.length; i++) {
      let line = '';
        for (let index in items[i]) {
            if (line != '') line += ','

            line += items[i][index];
        }
        csvContent += line + '\r\n';
    }

    return csvContent;
  },

  capitalizeFirstLetter(val) {
    return val ? val.charAt(0).toUpperCase() + val.slice(1) : "";
  },

  formatTimeBySeconds(milliseconds, removeLeadingZero=false) {
    let seconds = Math.floor(milliseconds / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    seconds = seconds % 60
    minutes = minutes % 60
    hours = hours % 60

    hours = hours < 10 ? "0"+hours: hours;
    minutes = minutes < 10 ? "0"+minutes: minutes;
    seconds = seconds < 10 ? "0"+seconds: seconds;

    if(removeLeadingZero) {
      if(hours == "00") {
        return `${minutes}:${seconds}`;
      }
      else if(minutes == "00") {
        return `${seconds}`;
      }
      else {
        return `${hours}:${minutes}:${seconds}`;
      }
    }
    else {
      if (hours === "00") {
        return `${minutes}:${seconds}`;
      } else {
        return `${hours}:${minutes}:${seconds}`;
      }
    }
  },

  formatTimeBySecondsInObj(milliseconds) {
    if(milliseconds == null) return null;

    let seconds = Math.floor(milliseconds / 1000)
    let minutes = Math.floor(seconds / 60)
    let hours = Math.floor(minutes / 60)
    seconds = seconds % 60
    minutes = minutes % 60
    hours = hours % 60

    hours = hours < 10 ? "0"+hours: hours;
    minutes = minutes < 10 ? "0"+minutes: minutes;
    seconds = seconds < 10 ? "0"+seconds: seconds;

    return {
      hours: hours,
      minutes: minutes,
      seconds: seconds
    }
  },

  messageIdToConversationId(messageId) {
    let conversationId = null;
    
    if(messageId) {
      let conversationIds = messageId.split(':::');
      if (conversationIds.length == 2) {
        conversationId = conversationIds[0];
      }
    }
    
    return conversationId;
  },

  getBrowserSessionStorageByUser(authUser, key) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        const userAndCompanyData = window.sessionStorage.getItem(userAndCompanyKey) ? JSON.parse(window.sessionStorage.getItem(userAndCompanyKey)) : {};
        return userAndCompanyData[key];
      }
      catch(e) {
        console.error(e);
      }
    }
    return null;
  },

  updateBrowserSessionStorageByUser(authUser, key, value) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        const userAndCompanyData = window.sessionStorage.getItem(userAndCompanyKey) ? JSON.parse(window.sessionStorage.getItem(userAndCompanyKey)) : {};
        userAndCompanyData[key] = value;
        window.sessionStorage.setItem(userAndCompanyKey, JSON.stringify(userAndCompanyData));
      }
      catch(err) {
        console.error(err);
      }
    }
  },

  resetBrowserSessionStorageByUser(authUser) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        window.sessionStorage.removeItem(userAndCompanyKey);
      }
      catch(err) {
        console.error(err);
      }
    }
  },

  getBrowserLocalStorageByUser(authUser, key) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        const userAndCompanyData = window.localStorage.getItem(userAndCompanyKey) ? JSON.parse(window.localStorage.getItem(userAndCompanyKey)) : {};
        return userAndCompanyData[key];
      }
      catch(e) {
        console.error(e);
      }
    }
    return null;
  },

  updateBrowserLocalStorageByUser(authUser, key, value) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        const userAndCompanyData = window.localStorage.getItem(userAndCompanyKey) ? JSON.parse(window.localStorage.getItem(userAndCompanyKey)) : {};
        userAndCompanyData[key] = value;
        window.localStorage.setItem(userAndCompanyKey, JSON.stringify(userAndCompanyData));
      }
      catch(err) {
        console.error(err);
      }
    }
  },

  resetBrowserLocalStorageByUser(authUser) {
    if(authUser && authUser.user) {
      try {
        const userAndCompanyKey = `${authUser.user.id}_${authUser.company.companyCode}`;
        window.localStorage.removeItem(userAndCompanyKey);
      }
      catch(err) {
        console.error(err);
      }
    }
  },

  replaceAt(str, index, replacement) {
    return str.slice(0, index) + replacement + str.slice(index + 1);
  },

  isValueInArray(value, arrayValues = [], caseSensitive = false) {
    try {
      return arrayValues.some(element => {
        if (typeof value !== "string" && typeof value !== "boolean") {
          return value === element;
        }
  
        const booleanMap = { "true": true, "false": false };
        if (typeof value === "boolean" || typeof element === "boolean") {
          if (caseSensitive) {
            return booleanMap[String(value)] === booleanMap[String(element)];
          } else {
            return booleanMap[String(value).toLowerCase()] === booleanMap[String(element).toLowerCase()];
          }
        }
  
        if (typeof value === "string" && typeof element === "string") {
          if (caseSensitive) {
            return value === element;
          } else {
            return value.toLowerCase() === element.toLowerCase();
          }
        }
        return false;
      });
    } catch (error) {
      console.error(`error while compare values in isValueInArray method : value ${value} in ${arrayValues}`, error);
      return false;
    }
  },

  hasFeatureFlagEnabled(featureFlags, key) {
    return featureFlags && featureFlags[key] && featureFlags[key] === true
  }
};

export default WyUtils;